/* eslint-disable no-shadow */
/* eslint-disable simple-import-sort/sort */
import { Grid } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link, Route } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import NoteAddIcon from '@material-ui/icons/NoteAdd'

import styles from '../../../resources/theme/global'
import { renderRoute } from '../../../util/utils'
import { fetchLaundries, makeReport } from '../LaundryActions'
import { getLaundryListData } from '../LaundryReducer'

import Filter from './Filter'
import List from './List'
import New from './New'
import Edit from './Edit'

class Laundries extends Component {
  componentDidMount() {
    const { fetchLaundries } = this.props
    fetchLaundries()
  }

  render() {
    const { classes, permissions, filters, makeReport } = this.props
    return (
      <>
        <Grid
          container
          className={classes.pageHead}
          spacing={1}
          alignItems="center"
        >
          <Grid item xs>
            <Typography variant="h4" color="secondary">
              Lavanderias
            </Typography>
          </Grid>
          <Grid item>
            <Filter classes={classes} />
          </Grid>
          <Grid item>
            <Button
              color="primary"
              type="button"
              onClick={() => makeReport(filters)}
            >
              <NoteAddIcon className={classes.btnIcon} /> Relatório
            </Button>
          </Grid>
          <Grid item>
            {renderRoute(['create-laundry'], permissions) && (
              <Button
                color="primary"
                variant="contained"
                component={Link}
                to="/laundry/new"
              >
                <AddCircleOutlineIcon className={classes.btnIcon} /> Cadastrar
              </Button>
            )}
          </Grid>
        </Grid>

        {renderRoute(['create-laundry'], permissions) && (
          <Route path="/laundry/new" component={New} />
        )}

        {renderRoute(['update-laundry'], permissions) && (
          <Route path="/laundry/:id/edit" component={Edit} />
        )}

        {renderRoute(['read-laundry'], permissions) && (
          <Route path="/laundry/:id/read-only" component={Edit} />
        )}

        <List {...this.props} classes={classes} />
      </>
    )
  }
}

const mapStateToProps = state => ({
  ...getLaundryListData(state),
  permissions: state.auth.permissions || [],
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchLaundries,
      makeReport,
    },
    dispatch
  )
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Laundries))
